import { Directive, effect, ElementRef, inject, input, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appShimmer]',
})
export class ShimmerDirective implements OnDestroy {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);

  readonly isLoading = input<boolean>(false, { alias: 'appShimmer' });
  readonly widthRem = input<number | null>(null, { alias: 'appShimmerWidthRem' });

  constructor() {
    effect(() => {
      const host = this.elementRef.nativeElement;

      if (this.isLoading()) {
        this.renderer.addClass(host, 'app-shimmer');

        if (this.widthRem() !== null) {
          this.renderer.setStyle(host, 'width', `${this.widthRem()}rem`);
          this.renderer.setStyle(host, 'display', 'inline-block');
        } else {
          this.renderer.removeStyle(host, 'width');
          this.renderer.removeStyle(host, 'display');
        }
      } else {
        this.renderer.removeClass(host, 'app-shimmer');
        this.renderer.removeStyle(host, 'width');
        this.renderer.removeStyle(host, 'display');
      }
    });
  }

  ngOnDestroy(): void {
    const host = this.elementRef.nativeElement;
    this.renderer.removeClass(host, 'app-shimmer');
    this.renderer.removeStyle(host, 'width');
    this.renderer.removeStyle(host, 'display');
  }
}
